<template>
    <div class="line">
        <div :id="echarts" :style="{width: '100%', 'height': height}"></div>
    </div>
</template>

<script>
    var echarts = require('echarts');
    export default {
        name: "line",
        props: {
            height: {
                type: String,
                default: '425px'
            },
            chartsData:{
                type:Object,
                default() {
                    return { title:'',legendData:[],xAxisData:[],yAxisName:'',highData:[],lowData:[],myData:[] }
                }
            }
        },
        data(){
            return{

            }
        },
        methods:{
            drawLine(){
                let myChart = echarts.init(document.getElementById(this.echarts));
                let color1 = new echarts.graphic.LinearGradient(0, 0, 0, 1,[{ offset: 0, color: "#F5674B" }, { offset: 1, color: "#E59A81" }],false);
                let color2 = new echarts.graphic.LinearGradient(0, 0, 0, 1,[{ offset: 0, color: "#3F72D9" }, { offset: 1, color: "#705DE4" }],false);
                myChart.setOption({
                    title: {
                        text: this.chartsData.title,
                        left: '45%',
                        bottom: '0',
                        textStyle: {
                            color: '#fff',
                            fontSize: 18,
                            align: 'center'
                        }
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        icon : 'roundRect',
                        textStyle: {
                            color: '#fff',
                            width: 240,
                            fontSize: '14'
                        },
                        itemGap: 24, // 设置legend的间距
                        itemWidth: 20, // 设置宽度
                        itemHeight: 20, // 设置高度
                        top:'5%',
                        right:'35%',
                        data: this.chartsData.legendData
                    },
                    color: [color1, color2],
                    grid: {
                        top: '20%',
                        left: '5%',
                        right: '0',
                        bottom:'9%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: true,
                        axisLabel:{
                            textStyle:{
                                color:'#fff'
                            }
                        },
                        data: this.chartsData.xAxisData
                    },
                    yAxis: {
                        name: this.chartsData.yAxisName,
                        type: 'value',
                        axisLine: {show:true},
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed'
                            }
                        },
                        axisLabel:{
                            textStyle:{
                                color:'#fff'
                            }
                        },
                        nameLocation:'end',
                        nameTextStyle:{
                            color:"#fff",
                            fontSize:11,
                            padding:[0, 50, 0, 0]
                        },
                    },
                    series: [
                        {
                            name: '今年发生情况',
                            type: 'line',
                            symbol: 'none',
                            lineStyle:{
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#F5674B'
                                }, {
                                    offset: 1,
                                    color: '#E59A81'
                                }]),
                            },
                            data: this.chartsData.highData
                        },
                        {
                            name: '去年发生情况',
                            type: 'line',
                            symbol: 'none',
                            lineStyle:{
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#3F72D9'
                                }, {
                                    offset: 1,
                                    color: '#705DE4'
                                }]),
                            },
                            data: this.chartsData.myData
                        },
                    ]
                });
            },
        },
        watch: {
            chartsData: {
                deep: true,
                handler: () => this.chartsData
            }
        },
        mounted() {
            this.drawLine();
            window.addEventListener("resize", this.drawLine);
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.drawLine);
        },
        computed: {
            echarts() {
                return 'echarts' + Math.random() * 100000;
            }
        },
    }
</script>

<style scoped>

</style>
